import { RoomCard } from "./room/room";
import { RoomsHeader } from "./rooms-header/rooms-header";
import { RoomsIntro } from "./rooms-intro/roomsintro";
import './rooms.scss';

export function Room(){
    return (
        <>
        <RoomsHeader/>
        <RoomsIntro/>
        <div className="room-types">
            <h2>Room Types</h2>
            <div className="room-types-intro">
                <p>
                    At Janas Hotel, we offer a variety of room types designed to meet your needs and exceed your expectations.
                    Each room combines modern amenities, cozy décor, and thoughtful details to ensure a relaxing and memorable stay.
                    Each room is equipped with high-speed Wi-Fi, a flat-screen TV, and all the little touches that make your stay feel like home.
                </p>
            </div>
            <div className="room-cards">
                <RoomCard />
            </div>
        </div>
        </>
    )
}